import React from 'react';
import { callApi } from '../../../Utils/Api/Api';
import OktaLogo from '../../../assets/logo/okta-logo.svg';
import { Button } from '@progress/kendo-react-buttons';

const OktaLoginButton = ({ setIsLoader, setAlertMessage }) => {
  const handleSocialLogin = async (driver) => {
    setIsLoader(true);
    try {
      const response = await callApi(
        `/social/auth/URL?driver=${driver}`,
        'GET'
      );
      if (response?.isSuccess) {
        window.location.href = response.payload.scalar;
      } else {
        setAlertMessage({
          alert: true,
          message: 'Failed to get social login URL. Please try again.',
        });
      }
    } catch (error) {
      console.error('Get social login URL error:', error);
      setAlertMessage({
        alert: true,
        message: 'Failed to get social login URL. Please try again.',
      });
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="social-login-box k-pt-2">
      <Button
        fillMode="outline"
        imageUrl={OktaLogo}
        imageAlt="Okta icon"
        className="single-login-btn"
        onClick={() => handleSocialLogin('okta')}
      >
        Sign in with OKTA
      </Button>
    </div>
  );
};

export default OktaLoginButton;
